module.exports = __webpack_public_path__ + "img/celular.4e04c5ec.svg";